
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"512","height":"512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M494.426 70.61c-11.332-11.329-26.395-17.57-42.414-17.57H452l-193.703-.005c-5.438.055-10.406-2.594-13.328-6.972L214.258 0H60C26.914 0 0 26.914 0 60v322.074c0 33.082 26.914 60 60 60h204v-40H60c-11.027 0-20-8.972-20-20V166.043c0-5.344 2.082-10.363 5.86-14.145a19.88 19.88 0 0114.144-5.855h.004l153.515-.008 31.286-45.52.156-.23c2.844-4.27 8.207-7.25 13.035-7.25v-.004c.066 0 .137.004.207.004h.137l193.66.004c5.34 0 10.36 2.078 14.137 5.856a19.871 19.871 0 015.859 14.14v200h40v-200c0-16.027-6.242-31.094-17.574-42.426zM211.77 77.964l-19.293 28.07-132.465.008H60a59.972 59.972 0 00-20 3.406V60c0-11.027 8.973-20 20-20h132.852l18.835 28.254a55.586 55.586 0 003.715 4.922 55.274 55.274 0 00-3.632 4.789zM428 353.035h84v40h-84v84h-40v-84h-84v-40h84v-84h40zm0 0","fill":"gray","data-original":"#000000"}})])
          )
        }
      }
    